import { LOAD_QUESTIONNAIRE } from "../actions/questionnaire-action";

const initialState = {
    id: '',
    name: '',
    sections: []
};

const QuestionnaireReducer = (state= initialState, action: any) => {
    switch(action.type) {
        case LOAD_QUESTIONNAIRE:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;     
    }
};

export default QuestionnaireReducer;